/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useDatasetImportsTableImportRowStyles = makeStyles({
  nameCell: {
    // width: "32%",
  },
  datasetControls: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  },
  controlIcon: {
    margin: '0 0 0 8px',
    color: '#A2A7AE',
    width: '24px',
    height: '24px',
    padding: '0',
    '&:hover': {
      color: '#BDC1C6',
    },
  },
  collapseIconButton: {
    padding: 0,
    marginRight: '8px',
  },
  mainRow: {
    backgroundColor: '#F6F7F8',
  },
  disabledErrorIcon: {
    '&.MuiIconButton-root.Mui-disabled': {
      color: '#FA634E',
    },
  },
});
